module.exports = __webpack_public_path__ + "img/main-spring.ad02f8af.jpg";